import styled from 'styled-components';
import { colors } from '../colors';

interface formGroupProps {
	padding?: string;
	margin?: string;
	marginBottom?: string;
	addUserSearch?: boolean;
	phoneNumber?: boolean;
	tradeSelect?: boolean;
	floatingGroup?: boolean;
	searchForProjects?: boolean;
	marginRight10?: boolean;
}

const FormGroup = styled.div<formGroupProps>`
	display: inline-block;
	width: 100%;
	position: relative;
	box-sizing: border-box;
	margin-bottom: ${({ marginBottom }) => marginBottom}!important;
	padding: ${({ padding }) => padding}!important;
	margin: ${({ margin }) => margin}!important;
	float: left;
	margin-bottom: 15px;
	${({ floatingGroup }) => floatingGroup && `position: relative; `}
	${({ marginRight10 }) => marginRight10 && `margin-right: 10px; `}

	${({ addUserSearch }) =>
		addUserSearch &&
		`position: relative;
		input{
			padding-right:50px;
		}
		span{
			font-size: 16px;
			color:${colors.White};
			
		}
		button{
			position:absolute;
			right:0px;
			top:1px;
			width:16px;
			background:${colors.Grey}
		}
	`}
	${({ phoneNumber }) =>
		phoneNumber &&
		`
		input{
			padding-left:50px;
		}
	`}
	${({ tradeSelect }) =>
		tradeSelect &&
		`margin:16px 0 0 0;
		width:250px!important;
		button{
			width:100%;
			height:37px;
			border:1px solid ${colors.GreyA0};
			border-radius: 0;
		}
		div{
			width:100%;
			color:${colors.Black};
		}
	`};
	${({ searchForProjects }) =>
		searchForProjects &&
		`width:450px!important;
		height: 48px;
		border-radius: 4px;
		position: relative;
		display: flex;
		background:${colors.White};
		overflow: hidden!important;
		margin-bottom: 113px;
		@media (max-width: 480px){
			width:90%!important;
		}
		input{
			border: none!important;
			height: 48px;
			outline: none!important;
			box-shadow: none;
			font-family: 'RubikMedium'!important;
			font-size: 13px;
			line-height: 19px;
		}
		button{
			width: 86px;
			height: 38px;
			background:${colors.BlueBase};
			color:${colors.White};
			border-radius: 3px;
			font-size: 12px;
			line-height: 18px;
			margin:5px;
			font-family: 'RubikMedium'!important;
			border: none!important;
			:hover{
				background:${colors.BlueDark};
			}
		}
	`};
`;

export default FormGroup;
